//libs

//styling
import './SocialLink.scss';

//assets

function SocialLink({ img, height = 50, width = 50, link, name }) {
  return (
    <a href={link} className="social" target="_blank" rel="noreferrer">
      <div className="social_link" style={{ height: height, width: width }}>
        <img src={img} alt={name} />
      </div>
      <span className="socail_ring_1" style={{ height: height + 10, width: width + 10 }}></span>
      <span className="socail_ring_2" style={{ height: height + 25, width: width + 25 }}></span>
      <span className="socail_ring_3" style={{ height: height + 40, width: width + 40 }}></span>
    </a>
  );
}

export default SocialLink;